import VuexPersist from 'vuex-persist';
import {
  SET_ANALYTICS_LOGGING_ENABLED,
  SET_PUBNUB_LOGGING_ENABLED,
} from '@/store/modules/dev-tools/devTools.mutations.type';

const filteredMutations = [
  'setExpire',
  'setFeatureFlags',
  'funNotifications/addFunNotification',
  'funNotifications/setViewedAuctionIds',
  'setAppLaunchMessage',
  'devFlags/setDevFlag',
  'setFirebaseDeviceToken',
  SET_ANALYTICS_LOGGING_ENABLED,
  SET_PUBNUB_LOGGING_ENABLED,
  'crossLanePromotionSettings/setCrossLanePromoSlidePage',
  'crossLanePromotionSettings/setShowCrossLanePromotionComponent',
  'laneSortingFilterSettings/setCachedSortSelection',
  'laneSortingFilterSettings/setCurrentSortSelection',
  'capitalRouting/setBreadcrumbsMutation',
  'capitalRouting/removeLastBreadcrumbMutation',
  'capitalRouting/clearBreadcrumbsMutation',
  'marketplaceRouter/setMarketplaceParams',
  'marketplaceView/setDismissedSimulcastPrompt',
  'marketplaceView/setEulaReviewBannerVisible',
];

const vuexLocalStorage = new VuexPersist({
  key: 'acv-storage',
  storage: window.localStorage,
  modules: [
    'dealershipAddress',
    'featureFlags',
    'funNotifications',
    'notifications',
    'devFlags',
    'devTools',
    'uiSettings',
    'offboarding',
    'firebase',
    'crossLanePromotionSettings',
    'laneSortingFilterSettings',
    'capitalRouting',
    'auctionAccess',
    'marketplaceRouter',
    'marketplaceView',
  ],
  filter: (mutation) => filteredMutations.includes(mutation.type),
  saveState: (key, state, storage) => {
    delete state.featureFlags.apiClient;
    delete state.featureFlags.existingRequest;
    delete state.featureFlags.featureFlagSlugs;
    delete state.notifications.counts;
    delete state.notifications.notifications;
    delete state.notifications.pagination;
    delete state.devFlags.devFlagSlugs;
    delete state.uiSettings;
    delete state.firebase.config;
    delete state.marketplaceView.laneCategoriesToggle;
    delete state.marketplaceView.srpRefreshPreference;
    delete state.marketplaceView.hasFetchedSrpRefreshPreference;
    delete state.marketplaceView.showingEventsDirectory;
    delete state.marketplaceView.searchAndFiltersTab;
    storage.setItem(key, JSON.stringify(state));
  },
  restoreState: (key, storage) => {
    const storageJSON = storage[key] || '{ "featureFlags": {}, "funAlerts": {} }';
    return JSON.parse(storageJSON);
  },
});

export default vuexLocalStorage;
